import { useLayoutEffect } from 'react';

import {
  useGetClassificationsQuery,
  useGetCostCenterTypeQuery,
  useGetDictionaryCurrencyQuery,
  useGetDictionaryPurchaseStatusesQuery,
  useGetDictionaryRequisitionStatusesQuery,
  useGetDocumentTypesQuery,
  useGetMrforQuery,
  useGetRFQStatusQuery,
  useGetTenderDocTypeQuery,
  useGetTenderExtensionTypeQuery,
  useGetTenderForQuery,
  useGetTenderModeQuery,
  useGetWarantyTypeQuery,
} from '@Store/api/dictionaryApiSlice';
import { useAppDispatch } from '@Hooks/index';
import { dictionaryActions } from '@Store/slices/dictionarySlice';
import RequestType from '@Enum/RequestTypes.enum';
import useRequestDictionaryLoader from './useRequestDictionaryLoader';

const useDictionaryLoader = (): void => {
  const requestName = useRequestDictionaryLoader();
  const dispatch = useAppDispatch();
  const currencyDict = useGetDictionaryCurrencyQuery(undefined, {
    skip: requestName !== RequestType.MATERIAL,
  });
  const requisitionStatusesDict = useGetDictionaryRequisitionStatusesQuery(
    undefined,
    {
      skip: requestName !== RequestType.MATERIAL,
    }
  );
  const costCenterTypeDict = useGetCostCenterTypeQuery(undefined, {
    skip: requestName !== RequestType.MATERIAL,
  });
  const warrantyTypeDict = useGetWarantyTypeQuery(undefined, {
    skip: requestName !== RequestType.MATERIAL,
  });

  const mrForDict = useGetMrforQuery(undefined, {
    skip: requestName !== RequestType.MATERIAL,
  });

  const purchaseClassificationsDict = useGetClassificationsQuery(undefined, {
    skip: requestName !== RequestType.PURCHASE,
  });
  const purchaseStatusesDict = useGetDictionaryPurchaseStatusesQuery(
    undefined,
    {
      skip: requestName !== RequestType.PURCHASE,
    }
  );
  const tenderForDict = useGetTenderForQuery(undefined, {
    skip: requestName !== RequestType.TENDER,
  });
  const tenderExtensionTypeDict = useGetTenderExtensionTypeQuery(undefined, {
    skip: requestName !== RequestType.TENDER,
  });
  const rfqStatus = useGetRFQStatusQuery(undefined, {
    skip: requestName !== RequestType.TENDER,
  });
  const tenderDocumentTypes = useGetTenderDocTypeQuery(undefined, {
    skip: requestName !== RequestType.TENDER,
  });
  const tenderModeTypes = useGetTenderModeQuery(undefined, {
    skip: requestName !== RequestType.TENDER,
  });
  const prForDict = useGetMrforQuery(undefined, {
    skip: requestName !== RequestType.TENDER,
  });
  const tenderClassificationsDict = useGetClassificationsQuery(undefined, {
    skip: requestName !== RequestType.TENDER,
  });

  const documentTypes = useGetDocumentTypesQuery();

  useLayoutEffect(() => {
    if (currencyDict?.data) {
      dispatch(dictionaryActions.setCurrencyDict(currencyDict.data));
    }
  }, [currencyDict?.data]);

  useLayoutEffect(() => {
    if (purchaseStatusesDict?.data) {
      dispatch(
        dictionaryActions.setPurchaseStatusesDict(purchaseStatusesDict.data)
      );
    }
  }, [purchaseStatusesDict?.data]);

  useLayoutEffect(() => {
    if (requisitionStatusesDict?.data) {
      dispatch(
        dictionaryActions.setRequisitionStatusesDict(
          requisitionStatusesDict.data
        )
      );
    }
  }, [requisitionStatusesDict?.data]);

  useLayoutEffect(() => {
    if (costCenterTypeDict?.data) {
      dispatch(dictionaryActions.setCostCenterType(costCenterTypeDict.data));
    }
  }, [costCenterTypeDict.data]);

  useLayoutEffect(() => {
    if (warrantyTypeDict?.data) {
      dispatch(dictionaryActions.setWarrantyType(warrantyTypeDict.data));
    }
  }, [warrantyTypeDict.data]);

  useLayoutEffect(() => {
    if (mrForDict?.data) {
      dispatch(dictionaryActions.setMrForType(mrForDict.data));
    }
  }, [mrForDict.data]);

  useLayoutEffect(() => {
    if (prForDict?.data) {
      dispatch(dictionaryActions.setMrForType(prForDict.data));
    }
  }, [prForDict.data]);

  useLayoutEffect(() => {
    if (tenderForDict?.data) {
      dispatch(dictionaryActions.setTenderForType(tenderForDict.data));
    }
  }, [tenderForDict.data]);

  useLayoutEffect(() => {
    if (tenderExtensionTypeDict?.data) {
      dispatch(
        dictionaryActions.setTenderExtensionType(tenderExtensionTypeDict.data)
      );
    }
  }, [tenderExtensionTypeDict.data]);

  useLayoutEffect(() => {
    if (rfqStatus?.data) {
      dispatch(dictionaryActions.setRFQStatus(rfqStatus.data));
    }
  }, [rfqStatus.data]);

  useLayoutEffect(() => {
    if (tenderDocumentTypes?.data) {
      dispatch(
        dictionaryActions.setTenderDocumentTypes(tenderDocumentTypes.data)
      );
    }
  }, [tenderDocumentTypes.data]);

  useLayoutEffect(() => {
    if (tenderModeTypes?.data) {
      dispatch(dictionaryActions.setTenderModeTypes(tenderModeTypes.data));
    }
  }, [tenderModeTypes.data]);

  useLayoutEffect(() => {
    if (documentTypes?.data) {
      dispatch(dictionaryActions.setDocumentTypes(documentTypes.data));
    }
  }, [documentTypes.data]);

  useLayoutEffect(() => {
    if (tenderClassificationsDict?.data) {
      dispatch(
        dictionaryActions.setPurchaseClassifications(
          tenderClassificationsDict.data
        )
      );
    }
  }, [tenderClassificationsDict.data]);

  useLayoutEffect(() => {
    if (purchaseClassificationsDict?.data) {
      dispatch(
        dictionaryActions.setPurchaseClassifications(
          purchaseClassificationsDict.data
        )
      );
    }
  }, [purchaseClassificationsDict.data]);
};

export default useDictionaryLoader;
